import { render, staticRenderFns } from "./workDetailList.vue?vue&type=template&id=0e06cf10&scoped=true"
import script from "./workDetailList.vue?vue&type=script&lang=js"
export * from "./workDetailList.vue?vue&type=script&lang=js"
import style0 from "./workDetailList.vue?vue&type=style&index=0&id=0e06cf10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e06cf10",
  null
  
)

export default component.exports